// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Iq-z","imageAndVideoCount":"Jq-z","imageAndVideoContainer":"Kq-z","viewAllReviews":"Lq-z"};